import { trpc } from 'root/src/client/v2/trpc/trpc';
import { DROPS_STALE_TIME_MS, DropsTabStatus, } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
// Total drops per status tab (Live / Coming soon / Private) for the tab count badges. Independent of
// the All / Recommended / Eligible filter chips and the search (those narrow the grid, not the tab
// total), mirroring how the other redesign list pages count their tabs; demo drops are excluded so
// the count matches what the grid shows.
//
// One `getDropsTabCounts` query, counted server-side. This used to be three separate `getDrops`
// queries with the LIST_VIEW serializer whose entire payloads were thrown away except for a
// `.length`, so the drops page pulled three complete drop collections on first paint to render three
// numbers.
export const useDropsTabCounts = () => {
    var _a, _b, _c;
    const counts = trpc.drops.getDropsTabCounts.useQuery(undefined, { staleTime: DROPS_STALE_TIME_MS });
    return {
        [DropsTabStatus.Live]: (_a = counts.data) === null || _a === void 0 ? void 0 : _a.live,
        [DropsTabStatus.Soon]: (_b = counts.data) === null || _b === void 0 ? void 0 : _b.soon,
        [DropsTabStatus.Private]: (_c = counts.data) === null || _c === void 0 ? void 0 : _c.private,
    };
};
